/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiatePaymentV2Response
 */
export interface InitiatePaymentV2Response {
    /**
     * 
     * @type {number}
     * @memberof InitiatePaymentV2Response
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentV2Response
     */
    reference: string;
}

/**
 * Check if a given object implements the InitiatePaymentV2Response interface.
 */
export function instanceOfInitiatePaymentV2Response(value: object): value is InitiatePaymentV2Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reference' in value) || value['reference'] === undefined) return false;
    return true;
}

export function InitiatePaymentV2ResponseFromJSON(json: any): InitiatePaymentV2Response {
    return InitiatePaymentV2ResponseFromJSONTyped(json, false);
}

export function InitiatePaymentV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentV2Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reference': json['reference'],
    };
}

export function InitiatePaymentV2ResponseToJSON(json: any): InitiatePaymentV2Response {
    return InitiatePaymentV2ResponseToJSONTyped(json, false);
}

export function InitiatePaymentV2ResponseToJSONTyped(value?: InitiatePaymentV2Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reference': value['reference'],
    };
}

